module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/about_us-de52da71bb7774750681184b4aa2113f.jpg";